import { render, staticRenderFns } from "./PurchasesPopularPoints.vue?vue&type=template&id=c8868732"
import script from "./PurchasesPopularPoints.vue?vue&type=script&lang=js"
export * from "./PurchasesPopularPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports